import React from "react";
import Modal from "./Modal";
import ContactForm from "../forms/ContactForm";
import { useBookingModal } from "../../contexts/BookingModalContext";

export default function BookingModal() {
  const { isOpen, closeModal } = useBookingModal();

  return (
    <Modal isOpen={isOpen} onClose={closeModal}>
      <ContactForm onSuccess={closeModal} />
    </Modal>
  );
}
